/**
 * FG UTM Tracker
 * Estrae il parametro utm_campaign dall'URL e lo salva in cart.attributes
 * così che possa essere utilizzato dai snippet di promozione
 */

(function() {
  // Leggi SOLO il parametro utm_campaign dall'URL
  const urlParams = new URLSearchParams(window.location.search);
  const utm_campaign = urlParams.get('utm_campaign');

  // Check se abbiamo già processato questo UTM per evitare loop
  const lastProcessedUTM = sessionStorage.getItem('lastProcessedUTM');

  // Se c'è il parametro utm_campaign E non lo abbiamo già processato
  if (utm_campaign && utm_campaign !== lastProcessedUTM) {
    // Salva il fatto che lo stiamo processando
    sessionStorage.setItem('lastProcessedUTM', utm_campaign);

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          utm_campaign: utm_campaign
        }
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('UTM campaign saved to cart:', data.attributes.utm_campaign);
      
      // Controlla se il popup esiste
      const popup = document.querySelector('fg-popup-banner');
      
      if (popup) {
        // Popup esiste, attendi la sua chiusura
        const checkClosed = setInterval(() => {
          if (popup.classList.contains('tw-hidden')) {
            clearInterval(checkClosed);
            window.location.reload();
          }
        }, 100);
        
        // Timeout di sicurezza (30 sec max)
        setTimeout(() => {
          clearInterval(checkClosed);
          window.location.reload();
        }, 60000);
      } else {
        // Popup non esiste, ricarica subito
        window.location.reload();
      }
    })
    .catch(error => {
      console.error('Error saving UTM campaign:', error);
    });
  }
})();

